import { cn } from "../ui/utils";

interface DropdownContentProps {
  children: React.ReactNode;
  className?: string;
  width?: "sm" | "md" | "lg";
}

const widthClasses = {
  sm: "w-60",
  md: "w-80",
  lg: "w-96"
};

export function DropdownContent({
  children,
  className,
  width = "sm"
}: DropdownContentProps) {
  return (
    <div className={cn(
      // max-h-80 (~8 options) + overflow-y-auto so long option lists
      // (e.g. the 14 EHR-native statuses on the MDS tab — NETSOL-11379)
      // scroll instead of overflowing the viewport.
      "absolute top-full left-0 mt-1 z-50 bg-white shadow-[0px_3px_14px_2px_rgba(0,0,0,0.12)] rounded border py-2 max-h-80 overflow-y-auto",
      widthClasses[width],
      className
    )}>
      {children}
    </div>
  );
}
